// Proje (Ekip Görevi) Oluştur / Projeyi Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'tasks.createTeamTask';

export const createTeamTaskGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Proje (ekip görevi) nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Bir ekibe ait projeyi açar, proje içindeki görevleri ekip üyelerine dağıtırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Proje bilgileri, görev ekleme ve görev tablosu'),
    footer: t(`${G}.regions.footer`, 'İptal / Projeyi Oluştur'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Proje adını yazın ve ekibi seçin'),
      text: t(`${G}.s1.text`, '"Proje Adı" ve "Ekip Seç" zorunludur. Görevler yalnız seçtiğiniz ekibin üyelerine atanabilir; ekip yoksa önce ekip oluşturun.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şube ve görev grubu (isteğe bağlı)'),
      text: t(`${G}.s2.text`, '"Şube Seç (Opsiyonel)" ve "Görev Grubu Seç (Opsiyonel)" ile projeyi bir şubeye ve görev grubuna bağlayabilirsiniz. Seçtiğiniz şube ve grup, projedeki tüm görevlere de yazılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sıralı mı, bağımsız mı?'),
      text: t(`${G}.s3.text`, '"Sıralı Görev Sistemi" (varsayılan) açıkken ekip üyeleri görevleri sırayla tamamlar: bir görev tamamlanmadan sonraki göreve geçilemez. Görevler eklendiği sırayla 1, 2, 3… diye numaralanır ve tabloda "Sıra" sütunu görünür. "Normal Ekip Görevi" seçilirse görevler birbirini beklemez; her üye kendi görevini bağımsız tamamlar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Sıralı sistemde bir görevi silerseniz kalan görevlerin sıra numaraları yeniden düzenlenir.'),
        t(`${G}.s3.tip2`, 'Bu seçimi projeyi ilk oluştururken yapın; mevcut projeyi düzenlerken değiştirmek kayda yansımaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Görevleri ekleyin'),
      text: t(`${G}.s4.text`, '"Görev Ekle" bölümünde Görev Adı ve Ekip Üyesi zorunludur; Öncelik (Düşük / Orta / Yüksek), Bitiş Tarihi, Bitiş Saati ve Görev Açıklaması isteğe bağlıdır. "Görev Ekle" düğmesine basınca görev "Eklenmiş Görevler" tablosuna geçer.'),
      tips: [
        t(`${G}.s4.tip1`, 'Her göreve en fazla 2 resim ekleyebilirsiniz: JPG, JPEG, PNG veya WEBP, en fazla 1 MB. Hatalı resim varsa kaldırmadan görev eklenmez.'),
        t(`${G}.s4.tip2`, 'Görev eklendikten sonra ekip üyesi ve tarih seçimi korunur; aynı kişiye arka arkaya görev ekleyebilirsiniz.'),
        t(`${G}.s4.tip3`, 'Tablodaki çöp kutusu görevi listeden çıkarır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Projeyi kaydedin'),
      text: t(`${G}.s5.text`, '"Projeyi Oluştur" projeyi ve görevlerini kaydeder; en az bir görev eklenmeden düğme açılmaz. Düzenlemede düğme "Değişiklikleri Kaydet" olur ve tablodan çıkardığınız görevler projeden silinir.'),
    },
  ],
});
